import {getAxios, User, Pageable} from '@deviceinsight/ng-ui-api-client';

const fetchAllAssetGroupsOfUser = (): Promise<Pageable<User>> =>
	getAxios()
		.get(`/v2/assetGroups`)
		.then((response) => response.data);

export {fetchAllAssetGroupsOfUser};
